var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_25878)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.219971,
    width: 60,
    height: 60,
    rx: 10,
    fill: "url(#paint0_linear_1_25878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2192 29.9976C58.2192 14.5336 45.6832 1.99756 30.2192 1.99756C14.7553 1.99756 2.21924 14.5336 2.21924 29.9976C2.21924 45.4615 14.7553 57.9976 30.2192 57.9976C45.6832 57.9976 58.2192 45.4615 58.2192 29.9976Z",
    fill: "url(#paint1_linear_1_25878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.22 57C15.3204 57 3.21997 44.8822 3.21997 30C3.21997 15.1178 15.3378 3 30.22 3C45.1021 3 57.22 15.1178 57.22 30C57.22 44.8822 45.1021 57 30.22 57Z",
    fill: "url(#paint2_linear_1_25878)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_1_25878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8497 18.2002C23.8497 21.5614 21.1322 24.2789 17.771 24.2789C14.4099 24.2789 11.6924 21.5614 11.6924 18.2002C11.6924 14.8391 14.4099 12.1216 17.771 12.1216C21.1322 12.1216 23.8497 14.8391 23.8497 18.2002Z",
    fill: "url(#paint3_linear_1_25878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7497 18.2002C23.7497 21.5062 21.077 24.1789 17.771 24.1789C14.4651 24.1789 11.7924 21.5062 11.7924 18.2002C11.7924 14.8943 14.4651 12.2216 17.771 12.2216C21.077 12.2216 23.7497 14.8943 23.7497 18.2002Z",
    stroke: "white",
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_1_25878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3075 41.7999C48.3075 45.161 45.59 47.8785 42.2288 47.8785C38.8677 47.8785 36.1501 45.161 36.1501 41.7999C36.1501 38.4387 38.8677 35.7212 42.2288 35.7212C45.59 35.7212 48.3075 38.4387 48.3075 41.7999Z",
    fill: "url(#paint4_linear_1_25878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2075 41.7999C48.2075 45.1058 45.5347 47.7785 42.2288 47.7785C38.9229 47.7785 36.2501 45.1058 36.2501 41.7999C36.2501 38.4939 38.9229 35.8212 42.2288 35.8212C45.5347 35.8212 48.2075 38.4939 48.2075 41.7999Z",
    stroke: "white",
    strokeWidth: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_1_25878",
    x: 9.69238,
    y: 10.1216,
    width: 16.1572,
    height: 16.1572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.306657 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25878"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25878",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_25878"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_1_25878",
    x: 34.1501,
    y: 33.7212,
    width: 16.1572,
    height: 16.1572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.306657 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_25878"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_25878",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1_25878"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_25878",
    x1: 59.4512,
    y1: 59.2312,
    x2: 0.988744,
    y2: 0.768773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03539"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_25878",
    x1: 11.6886,
    y1: 11.4669,
    x2: 49.1889,
    y2: 48.9672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F54141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F35656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_25878",
    x1: 50.3689,
    y1: 49.6627,
    x2: 9.04013,
    y2: 10.2788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DA2228"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_25878",
    x1: 21.3466,
    y1: 22.5089,
    x2: 13.991,
    y2: 13.4202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672621,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_25878",
    x1: 45.8043,
    y1: 46.1086,
    x2: 38.4487,
    y2: 37.0198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672621,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_25878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.219971)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2);
export default __webpack_public_path__ + "static/media/b2.ea7bfe4e97ad00e412e95f0a5ce9f1f9.svg";
export { ForwardRef as ReactComponent };